import type { AquacultureSite } from './types';

function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}

function text(value: unknown): string | undefined {
    return typeof value === 'string' ? value : undefined;
}

function num(value: unknown): number | undefined {
    return typeof value === 'number' ? value : undefined;
}

function toSite(site: Record<string, unknown>): AquacultureSite {
    const placement = isRecord(site.placement) ? site.placement : {};
    const siteNr = num(site.siteNr);
    return {
        id: siteNr,
        value: text(site.name),
        municipality: text(placement.municipalityName),
        county: text(placement.countyName),
        latitude: num(site.latitude),
        longitude: num(site.longitude),
        fishTypeName: text(site.fishTypeName),
        aquacultureSiteId: siteNr?.toString(),
    };
}

/** The register's search reply. Anything that is not a list of sites reads as no sites. */
export function toAquacultureSites(body: unknown): AquacultureSite[] {
    return Array.isArray(body) ? body.filter(isRecord).map(toSite) : [];
}
